import { default as ar } from './locale/ar.json';
import { default as ca } from './locale/ca.json';
import { default as cs } from './locale/cs.json';
import { default as da } from './locale/da.json';
import { default as de } from './locale/de.json';
import { default as el } from './locale/el.json';
import { default as en } from './locale/en.json';
import { default as es } from './locale/es.json';
import { default as fa } from './locale/fa.json';
import { default as fi } from './locale/fi.json';
import { default as fr } from './locale/fr.json';
import { default as hi } from './locale/hi.json';
import { default as hu } from './locale/hu.json';
import { default as id } from './locale/id.json';
import { default as it } from './locale/it.json';
import { default as ja } from './locale/ja.json';
import { default as ko } from './locale/ko.json';
import { default as ml } from './locale/ml.json';
import { default as nl } from './locale/nl.json';
import { default as no } from './locale/no.json';
import { default as pl } from './locale/pl.json';
import { default as pt } from './locale/pt.json';
import { default as pt_BR } from './locale/pt_BR.json';
import { default as ro } from './locale/ro.json';
import { default as ru } from './locale/ru.json';
import { default as sk } from './locale/sk.json';
import { default as sv } from './locale/sv.json';
import { default as ta } from './locale/ta.json';
import { default as tr } from './locale/tr.json';
import { default as uk } from './locale/uk.json';
import { default as vi } from './locale/vi.json';
import { default as zh_CN } from './locale/zh_CN.json';
import { default as zh_TW } from './locale/zh_TW.json';

export default {
  ar,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  fa,
  fi,
  fr,
  hi,
  hu,
  id,
  it,
  ja,
  ko,
  ml,
  nl,
  no,
  pl,
  pt,
  pt_BR,
  ro,
  ru,
  sk,
  sv,
  ta,
  tr,
  uk,
  vi,
  zh_CN,
  zh_TW,
};
